import { render } from "./Comments.vue?vue&type=template&id=9f17c5c6"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
script.render = render

export default script